import {useRef, useState} from "react";
import {
	Box,
	Button, Collapse,
	Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {gql, useQuery} from "@apollo/client";

import StaticAvatar from "../../../../components/StaticAvatar";
import {useRouter} from "next/router";
import {useKeycloak} from "../../../../src/useKeycloak";

const GET_USER = gql`
query getMyUserdata($id: uuid = "") {
  user(id: $id) {
    username
    id
    firstName
    lastName
  }
}
`;

const UserBoxButton = styled(Button)(
	({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const UserBoxText = styled(Box)(
	({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
	({ theme }) => `
        /*font-weight: ${theme.typography.fontWeightBold};*/
        font-size: 14px;
        color: ${theme.palette.text.primary};
        display: block;
`
);

function HeaderUserbox() {
	const router = useRouter();
	const {tokenParsed} = useKeycloak();
	const [showName, setShowName] = useState(false);
	const ref = useRef(null);

	const { loading, error, data } = useQuery(GET_USER, {variables: {id: tokenParsed?.sub}});

	const handleUserClick = () => {
		router.push("/profile");
	};

	if (loading) return (<div />);
	if (error) { return (<div>{error.message}</div>); }

	 let timer;

	return (
		<>
			<UserBoxButton
				color="primary"
				ref={ref}
				sx={{marginRight: 2, p: 1}}
				onClick={handleUserClick}
				onMouseEnter={() => {
					if (timer) clearTimeout(timer);
					timer = setTimeout(() => {
						setShowName(true);
					}, 400);
				}}
			   onMouseLeave={() => {
					if (timer) clearTimeout(timer);
				   timer = setTimeout(() => {
				   setShowName(false);
			   }, 500);
				}}
			>
				<StaticAvatar
					user={data?.user}
					sx={{height: "44px", width: "44px", mr: 0, fontSize: "18px"}}
				/>
				<Collapse
					orientation="horizontal"
					in={showName}
					timeout={500}
				>
					<UserBoxText>
						<UserBoxLabel noWrap={true} variant="body1">{data?.user?.firstName  + " " + data?.user?.lastName }</UserBoxLabel>
					</UserBoxText>
				</Collapse>

			</UserBoxButton>
		</>
	);
}

export default HeaderUserbox;
